/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/* eslint-disable */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';
import { buildUsersSearchQueryString, shouldFetchUsersSearch } from '../utils/userSearchUtils';

export default class ChatutilityUsersService extends BaseService {
  constructor() {
    super(constants.MANAGE_USERS_DATA_FETCHED_TENANT, 'tenantUsersStatus');
  }

  handleEvent(eventName, event) {
    const { searchParams, tenantId, roleId } = event;
    const headers = utils.buildHeadersWithTenantId(event);

    if (shouldFetchUsersSearch(searchParams, roleId)) {
      const queryString = buildUsersSearchQueryString(searchParams, roleId);
      return this.getClient('aiadmin').get(`/users/search?${queryString}`, { headers });
    }

    return this.getClient('aiadmin').get('/users', { headers });
  }

  handleResponse(response) {
    // eslint-disable-line class-methods-use-this

    Framework.getStoreRegistry().getStore('chatutilityusersState').set(response.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }
  }
}
